export const EXPAND_INTERACTIVE_ELEMENTS_LIST = 'InteractiveElementsList.EXPAND'
export const MINIMIZE_INTERACTIVE_ELEMENTS_LIST = 'InteractiveElementsList.MINIMIZE'
export const HIDE_INTERACTIVE_ELEMENTS_LIST = 'InteractiveElementsList.HIDE'
export const LIST_ITEM_SELECTED = 'InteractiveElementsList.LIST_ITEM_SELECTED'

export const expandInteractiveElementsList = () => ({
    type: EXPAND_INTERACTIVE_ELEMENTS_LIST,
})

export const minimizeInteractiveElementsList = () => ({
    type: MINIMIZE_INTERACTIVE_ELEMENTS_LIST,
})

export const hideInteractiveElementsList = () => ({
    type: HIDE_INTERACTIVE_ELEMENTS_LIST,
})

export const listItemSelected = ({ id, elementType }) => ({
    type: LIST_ITEM_SELECTED,
    id,
    elementType,
})
